import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import { PlusCircleOutlined } from '@ant-design/icons';
import { Input, Radio } from 'antd';
import { PACKAGE, PCB_PRE_LAYOUT } from "../../../constants/treeConstants";
import { BGA, DIE, IC, PMIC } from "../../../constants/componentType";
import {
  Canvas,
  decapHeight,
  totalHeight,
  marginWidth,
  componentWidth,
  parasiticsWidth,
  parasiticsSpace,
  decapWholeWidth,
  decapWidth,
  caclDecapPosition,
  AC_PLOT_NET_SPACE,
  decapGroupMargin,
  AC_PLOT_POWER_HEIGHT
} from "../../../services/Cascade/prelayout";
import { createDecapGroup, createPowerNet, deletePowerNet, showDecapGroup, updateBall, updateCanvasStatus, updatePorts, updatePowerNetName, updatePreLayoutType, updateVoltage } from "../store/prelayout/action";
import { getTextWidth } from "../../../services/helper/getTextWidth";
import { numberCheck } from "../../../services/helper/dataProcess";
import './index.css';
import { AC_PLOT_MODEL_HEIGHT, AC_PLOT_MODEL_SPACE, AC_PLOT_POWER_NET_HEIGHT, SCHEMATIC, SPICE } from "../../../services/Cascade/prelayout/constants";
import { defaultColor_dark } from "../../../constants/defaultColors";
import PreLayoutModelPanel from "./preLayoutModelPanel";

class Setup extends Component {

  constructor() {
    super();
    this.state = {
      height: totalHeight,
      decapsPosition: [],
      inputVoltage: "",
      modelVisible: false
    }
  }

  componentDidMount() {
    this.getCanvansWidth();
    window.addEventListener('resize', this.resize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  componentDidUpdate = (prevProps) => {
    const { id, loading, viewList, canvasUpdate } = this.props;
    const { width } = this.state;

    if (canvasUpdate) {
      this.getCanvansWidth()
      this.props.updateCanvasStatus(false)
    }

    if (id !== prevProps.id || ((!prevProps.viewList || !prevProps.viewList.includes(PCB_PRE_LAYOUT)) && viewList.includes(PCB_PRE_LAYOUT))) {
      if (id !== prevProps.id) {
        this.brush = null;
      }
      this.getCanvansWidth();
    }

    if (loading !== prevProps.loading) {
      const ele = document.getElementById(`pre-layout-${id}`);
      const offset = ele ? ele.getBoundingClientRect() : null;
      const offsetWidth = offset && offset.width ? offset.width < 1000 ? 1000 : offset.width : 1000;
      if (width !== offsetWidth) {
        this.getCanvansWidth()
      }
    }
  }

  resize = () => {
    this.getCanvansWidth()
  }

  addNewDecapGroup = (powerNet) => {
    this.props.createDecapGroup(powerNet)
  }

  addNewPowerNet = (e) => {
    e && e.stopPropagation();
    this.props.createNewPowerNet()
  }

  getCanvansWidth = () => {
    const { id, decapGroups, powerNets = [] } = this.props;
    const ele = document.getElementById(`pre-layout-${id}`);
    const offset = ele ? ele.getBoundingClientRect() : null;
    const offsetWidth = offset && offset.width ? offset.width < 1000 ? 1000 : offset.width : 1000;
    const decapNumber = decapGroups.reduce((prev, group) => {
      return prev + group.decaps.length
    }, 0)
    const _width = marginWidth * 2 + componentWidth * 2 + parasiticsWidth + parasiticsSpace * 2 + decapNumber * decapWholeWidth;
    const decapsPosition = caclDecapPosition(decapGroups, powerNets);
    this.setState({
      width: _width > offsetWidth ? _width : offsetWidth,
      height: totalHeight + (powerNets.length - 1 > 0 ? powerNets.length - 1 : 0) * AC_PLOT_NET_SPACE,
      decapsPosition,
      modelVisible: false
    }, () => {
      this.draw()
    })
  }

  draw = () => {
    const { width, height, decapsPosition } = this.state;
    const { preLayoutType } = this.props
    if (!this.brush) {
      const { id } = this.props;
      if (!id) {
        return;
      }
      this.brush = new Canvas({ id: `pre-layout-canvas-${id}`, width, height, preLayoutType });
    }
    const { powerNets, referenceNets } = this.props;
    this.brush.reset({ width, height, preLayoutType })
    this.brush.set('powerNets', powerNets);
    this.brush.set('referenceNets', referenceNets);
    this.brush.set('decaps', decapsPosition);
    this.brush.draw();
    this.setState({
      width
    })
  }

  inputVoltageStatus = (e, input) => {
    e && e.stopPropagation();
    this.setState({
      inputVoltage: input
    }, () => {
      this.inputRef && this.inputRef.focus()
    })
  }

  inputVoltageBlur = (e) => {
    const voltage = e.target.value;
    const { inputVoltage } = this.state;
    const error = numberCheck(voltage);
    if (!error) {
      this.props.updateVoltage(inputVoltage, voltage)
    }
    this.setState({
      inputVoltage: ""
    })
  }

  setBall = (e, key) => {
    e && e.stopPropagation();
    this.setState({
      [key]: true
    }, () => {
      this.inputRef && this.inputRef.focus()
    })
  }

  inputBall = (e, key, ballKey, powerNet) => {
    const value = e.target.value;
    const error = numberCheck(value);
    if (!error) {
      this.props.updateBall(key, value, powerNet)
    }
    this.setState({
      [`${powerNet}-${ballKey}`]: ""
    })
  }

  changeEditPowerNetName = (powerNet) => {
    this.setState({
      editPowerNet: powerNet
    }, () => {
      this.inputNameRef && this.inputNameRef.focus()
    })
  }

  inputPowerNet = (e) => {
    const { editPowerNet } = this.state;
    const newPowerNet = e.target.value;
    if (editPowerNet !== newPowerNet) {
      this.props.updatePowerNetName(editPowerNet, newPowerNet)
    }
    this.setState({
      editPowerNet: ""
    })
  }

  deletePowerNet = (powerNet) => {
    this.props.deletePowerNet(powerNet)
  }

  onPressEnter = (e) => {
    e.target.blur();
  }

  radioChange = async (e) => {
    const type = e.target.value;
    await this.props.updatePreLayoutType(type)
    this.draw()
  }

  canvasRender = () => {
    const { width, height } = this.state;
    const { id } = this.props;
    return <canvas id={`pre-layout-canvas-${id}`} className="pre-layout-canvas" width={width} height={height} />
  }

  componentsRender = () => {
    const { components, preLayoutType } = this.props;
    const { width } = this.state;
    const pmic = components.filter(item => item.type === PMIC || item.type === BGA);
    const ic = components.filter(item => item.type === IC || item.type === DIE);
    return <div style={{ width }} className="pre-layout-relative">
      {this.componentRender(pmic, 'left', '#f47188')}
      {this.componentRender(ic, 'right', '#6495ed')}
      {preLayoutType === SCHEMATIC ? this.decapGroupsRender() : null}
    </div>
  }

  componentRender = (comps, side) => {
    const { height } = this.state;
    const { isPackage } = this.props;
    let _height = height / comps.length;
    return comps.map((comp, index) => {
      const { name } = comp
      return <div
        style={{ top: _height * index, height: _height - 40, lineHeight: `${_height - 40}px` }}
        className={`setup-component setup-component-${side}`}
        key={name}
      >
        {name}
        {!isPackage ? side === 'right' ? ' (IC)' : ' (PMIC)' : null}
        {/* {side === 'left' && !isPackage && <span className='setup-voltage' onClick={(e) => this.inputVoltageStatus(e, name)}>{
          inputVoltage === name ?
            <Input className='aurora-input' defaultValue={voltage} ref={(input) => this.inputRef = input} onBlur={(e) => this.inputVoltageBlur(e)} onPressEnter={this.onPressEnter} />
            :
            <span> {voltage ? voltage : '___'}V</span>
        }</span>} */}
      </div>
    })
  }

  addPowerNetRender = () => {
    return (
      <div className="add-decap-group" onClick={this.addNewPowerNet}>
        <PlusCircleOutlined />
        <span>Add Power Net</span>
      </div>
    );
  }

  // addGroupRender = () => {
  //   return (
  //     <div className="add-decap-group" onClick={this.addNewDecapGroup}>
  //       <PlusCircleOutlined />
  //       <span>Add Decap Group</span>
  //     </div>
  //   );
  // }

  decapGroupsRender = () => {
    const { decapGroups, groupShow } = this.props;
    const { decapsPosition } = this.state;
    return decapGroups.map((group, index) => {
      const { name, decaps } = group;
      const _group = decapsPosition.find(item => item.name === name)
      if (!_group) {
        return null;
      }
      const { top, x, decaps: decapsPos } = _group;
      return <Fragment key={name}>
        {this.decapGroupRender(name, group, x, top, groupShow === name ? true : false, true, decaps.length)}
        <div className="group-decaps">
          {
            decaps.map((item, index) => {
              const findDecap = decapsPos.find(pos => pos.name === item.name && index === pos.index);
              return findDecap ? this.decapRender(name, item, findDecap.x, top + decapHeight, false, false, index) : null
            })
          }
        </div>
      </Fragment>
    })
  }

  decapGroupRender = (groupName, data, left, top, select, isGroup, childNumber) => {
    const { name, l_group, r_group } = data;
    const childWidth = (childNumber - 1) * (decapWidth + parasiticsSpace)
    return <div
      style={{ left: left - (decapGroupMargin + childWidth) / 2, top: top - decapGroupMargin / 2, width: decapWidth + decapGroupMargin + childWidth, height: 2 * decapHeight + decapGroupMargin }}
      className={`setup-decap-group ${select ? 'setup-decap-group-select' : ''} ${isGroup ? 'setup-decap-groups' : 'setup-decap-item'}`}
      onClick={() => this.props.showDecapGroup(groupName)}
      key={name}
      title={name}
    >
      <div className='decap-name'>{name}</div>
      <div className='decap-r'>R Group: {r_group || r_group === 0 ? r_group : '___'}mΩ</div>
      <div className='decap-l'>L Group: {l_group || l_group === 0 ? l_group : '___'}pH</div>
    </div>
  }

  decapRender = (groupName, data, left, top, select, isGroup, index) => {
    const { name, l_layout, r_layout, number } = data;
    const textWidth = getTextWidth(name, 12, null, 'bold');
    return <div
      style={{ left, top, width: decapWidth, height: decapHeight }}
      className={`setup-decap-group ${select ? 'setup-decap-group-select' : ''} ${isGroup ? 'setup-decap-groups' : 'setup-decap-item'}`}
      onClick={() => this.props.showDecapGroup(groupName)}
      key={name + index}
      title={name}
    >
      <div className='decap-name' style={{ left: `calc(50% - 0.5 * ${textWidth > 120 ? 120 : textWidth}px)` }}>{name}</div>
      <div className='decap-r'>R: {r_layout || r_layout === 0 ? r_layout : '___'}mΩ</div>
      <div className='decap-l'>L: {l_layout || l_layout === 0 ? l_layout : '___'}pH</div>
      <div className='decap-number'>x{number}</div>
    </div>
  }

  ballRender = (powerNet, index) => {
    const { balls, isPackage } = this.props;
    const ball = balls[powerNet] || {}
    const { l = "", r = "", c = "" } = ball;
    const defaultLeft = componentWidth + parasiticsSpace;
    const ballWidth = parasiticsWidth / 3;
    return <div className={`setup-ball`} style={{ top: (isPackage ? 0 : 40) + index * AC_PLOT_NET_SPACE }}>
      <div className={this.state[`${powerNet}-ballR`] ? 'decap-r select-decap-r' : 'decap-r'} onClick={(e) => this.setBall(e, `${powerNet}-ballR`)} style={{ left: defaultLeft + 10 + ballWidth }}>
        {this.state[`${powerNet}-ballR`] ? <Input className='aurora-input' defaultValue={r} ref={(input) => this.inputRef = input} onPressEnter={this.onPressEnter} onBlur={(e) => this.inputBall(e, 'r', 'ballR', powerNet)} addonAfter='mΩ' /> : <span>R: {r || r === 0 ? r : '___'}mΩ</span>}
      </div>
      <div className={this.state[`${powerNet}-ballL`] ? 'decap-l select-decap-l' : 'decap-l'} onClick={(e) => this.setBall(e, `${powerNet}-ballL`)} style={{ left: defaultLeft + 10 }}>
        {this.state[`${powerNet}-ballL`] ? <Input className='aurora-input' defaultValue={l} ref={(input) => this.inputRef = input} onPressEnter={this.onPressEnter} onBlur={(e) => this.inputBall(e, 'l', 'ballL', powerNet)} addonAfter='nH' /> : <span>L: {l || l === 0 ? l : '___'}nH</span>}
      </div>
      <div className={this.state[`${powerNet}-ballC`] ? 'decap-c select-decap-c' : 'decap-c'} onClick={(e) => this.setBall(e, `${powerNet}-ballC`)} style={{ left: defaultLeft + 10 + 2.5 * ballWidth }}>
        {this.state[`${powerNet}-ballC`] ? <Input className='aurora-input' defaultValue={c} ref={(input) => this.inputRef = input} onPressEnter={this.onPressEnter} onBlur={(e) => this.inputBall(e, 'c', 'ballC', powerNet)} addonAfter='pF' /> : <span>C: {c || c === 0 ? c : '___'}pF</span>}
      </div>
    </div>
  }

  showModel = () => {
    this.setState({
      modelVisible: true
    })
  }

  closeModal = (files, ports) => {
    this.props.updatePorts(files, ports)
    this.setState({
      modelVisible: false
    })
  }

  modelRender = (powerNet, index, color) => {
    const { model } = this.props
    const ports = model && model.ports ? model.ports : []
    const files = model && model.files ? model.files : []

    const group = ports.find(item => item.powerNet === powerNet) || {};
    const icPorts = group.icPorts || [];
    const pmicPorts = group.pmicPorts || [];

    const portKeys = [...icPorts, ...pmicPorts].map(p => p.modelKey).filter(Boolean);
    const fileName = files
      .filter(f => portKeys.includes(f.modelKey))
      .map(f => f.subckt ? `${f.fileName}::${f.subckt}` : f.fileName)
      .join(', ');

    const icPortsLength = icPorts.length || 1;
    const pmicPortsLength = pmicPorts.length || 1;
    return <Fragment>
      <div
        className="setup-model"
        style={{ top: AC_PLOT_MODEL_HEIGHT + index * AC_PLOT_MODEL_SPACE, borderColor: color }}
        onClick={() => this.showModel()}
      >
        <div className="setup-model-file">
          {
            fileName ? <Fragment>
              <span title={fileName}>{fileName}</span>
            </Fragment> :
              <div className='cascade-layout-model-empty'>Click to set model</div>
          }
        </div>
      </div>
      <div
        className="setup-model-pmic-ports"
        style={{ top: AC_PLOT_MODEL_HEIGHT + index * AC_PLOT_MODEL_SPACE }}
      >
        {`${pmicPortsLength} ${pmicPortsLength === 1 ? 'Port' : 'Ports'}`}
      </div>
      <div
        className="setup-model-ic-ports"
        style={{ top: AC_PLOT_MODEL_HEIGHT + index * AC_PLOT_MODEL_SPACE }}
      >
        {`${icPortsLength} ${icPortsLength === 1 ? 'Port' : 'Ports'}`}
      </div>
    </Fragment>
  }

  powerNetNameRender = (powerNet, index) => {
    const { editPowerNet, inputVoltage } = this.state;
    const { voltages, isPackage, preLayoutType } = this.props;
    const voltage = voltages[powerNet] || ''
    return <div className={`setup-power-net-name`} style={{ top: (isPackage ? AC_PLOT_POWER_HEIGHT : AC_PLOT_POWER_NET_HEIGHT) + 10 + index * AC_PLOT_NET_SPACE }}>
      <div className='power-net-name'>
        {
          editPowerNet === powerNet ? <Input defaultValue={powerNet} ref={(input) => this.inputNameRef = input} onBlur={(e) => this.inputPowerNet(e)} onPressEnter={this.onPressEnter} /> : <span>{powerNet}</span>
        }
      </div>
      {isPackage ? null :
        <div className='power-net-voltage' onClick={(e) => this.inputVoltageStatus(e, powerNet)}>
          {inputVoltage !== powerNet ? <Fragment>
            <span>Nominal Voltage: </span>
            <span>{voltage ? voltage : '____'}</span>
            <span> V</span>
          </Fragment>
            :
            <Input className='aurora-input' defaultValue={voltage} ref={(input) => this.inputRef = input} onBlur={(e) => this.inputVoltageBlur(e)} onPressEnter={this.onPressEnter} />
          }
        </div>
      }
      <div className='power-net-button'>
        {preLayoutType === SCHEMATIC ? <Fragment>
          <span onClick={() => this.addNewDecapGroup(powerNet)}>Add decap group</span>
          |
        </Fragment> : null}
        <span onClick={() => this.changeEditPowerNetName(powerNet)}>Rename</span>
        {
          index > 0 ? <Fragment>
            |
            <span onClick={() => this.deletePowerNet(powerNet)}>Delete</span>
          </Fragment> : null
        }
      </div>
    </div>
  }

  powerNetsRender = () => {
    const { powerNets, preLayoutType } = this.props;
    const colorMap = new Map();
    for (let i = 0; i < powerNets.length; i++) {
      colorMap.set(powerNets[i], defaultColor_dark[i % powerNets.length])
    }
    return powerNets.map((powerNet, index) => <Fragment key={powerNet}>
      {preLayoutType === SCHEMATIC ? this.ballRender(powerNet, index) : this.modelRender(powerNet, index, colorMap.get(powerNet))}
      {this.powerNetNameRender(powerNet, index)}
    </Fragment>)
  }

  preLayoutTypeRender = () => {
    const { preLayoutType } = this.props
    return <div className="cascade-pre-layout-type-body">
      <span className="cascade-pre-layout-type-span">Pre-Layout Type</span>
      <Radio.Group value={preLayoutType} onChange={(e) => this.radioChange(e)} className="cascade-pre-layout-type-radio-group">
        <Radio value={SCHEMATIC}>Schematic</Radio>
        <Radio value={SPICE}>SPICE / Touchstone</Radio>
      </Radio.Group>
    </div>
  }

  render() {
    const { id, customSpiceList, customTouchstoneList, powerNets, isPackage, model } = this.props;
    const { modelVisible } = this.state
    return <Fragment>
      {/* <span className="font-bold cascade-setup-title-color-only">Setup</span> */}
      <div id={`pre-layout-${id}`} className="cascade-prelayout-setup">
        {isPackage ? null : this.preLayoutTypeRender()}
        {this.addPowerNetRender()}
        {this.componentsRender()}
        {this.canvasRender()}
        {this.powerNetsRender()}
        {modelVisible ? <PreLayoutModelPanel
          customSpiceList={customSpiceList}
          customTouchstoneList={customTouchstoneList}
          model={model}
          powerNets={powerNets}
          closeModal={this.closeModal}
        /> : null}
      </div>
    </Fragment>
  }
}

const mapState = (state) => {
  const { CascadeReducer: { prelayout: { content = {}, id, canvasUpdate, groupShow, type, preLayoutType }, project: { viewList }, library: { customSpiceList = [], customTouchstoneList = [] } } } = state;
  const { components = [], powerNets = [], referenceNets = [], decapGroups = [], balls = {}, voltages = {}, model = {} } = content
  return {
    components,
    id,
    loading: false,
    viewList,
    powerNets,
    referenceNets,
    decapGroups,
    canvasUpdate,
    groupShow,
    balls,
    voltages,
    isPackage: type === PACKAGE ? true : false,
    model,
    customSpiceList,
    customTouchstoneList,
    preLayoutType: preLayoutType || SCHEMATIC
  }
}

const mapDispatch = (dispatch) => ({
  createDecapGroup(powerNet) {
    dispatch(createDecapGroup(powerNet))
  },
  updateCanvasStatus(boolean) {
    dispatch(updateCanvasStatus(boolean))
  },
  showDecapGroup(groupName) {
    dispatch(showDecapGroup(groupName))
  },
  updateVoltage(name, voltage) {
    dispatch(updateVoltage(name, voltage))
  },
  updateBall(key, value, powerNet) {
    dispatch(updateBall(key, value, powerNet))
  },
  createNewPowerNet() {
    dispatch(createPowerNet())
  },
  updatePowerNetName(name, newName) {
    dispatch(updatePowerNetName(name, newName))
  },
  deletePowerNet(name) {
    dispatch(deletePowerNet(name))
  },
  updatePorts(files, ports) {
    dispatch(updatePorts(files, ports))
  },
  updatePreLayoutType(type) {
    dispatch(updatePreLayoutType(type))
  }
})

export default connect(mapState, mapDispatch)(Setup);